import React from "react";
import { useSelector } from "react-redux";
import Button from "../Button/Button";
import "./GameOutcomeDisplay.css";

const GameOutcomeDisplay = () => {
  const isGameOver = useSelector((state) => state.game.gameOver);
  const isGameWon = useSelector((state) => state.game.gameWon);
  const gameOverMessage = useSelector((state) => state.game.gameOverMessage);

  return (
    <div className="game-over-container" data-testid="game-over">
      {isGameWon ? (
        <div>
          <h2 className="win-font">WELL DONE SOLDIER!</h2>
          <h3>INFILTRATION SUCCESSFUL</h3>
          <h4 className="stats-font">STATS:</h4>
          <h5 className="stats-font">{gameOverMessage.destroyedEnemies}</h5>
          <h5 className="stats-font">{gameOverMessage.crew}</h5>
        </div>
      ) : isGameOver ? (
        <div>
          <h1 className="loss-font">GAME OVER</h1>
          <h3>INFILTRATION UNSUCCESSFUL</h3>
          <h4 className="message">{gameOverMessage.outcome}</h4>
        </div>
      ) : null}
      {(isGameOver || isGameWon) && (
        <div style={{ padding: "1px" }}>
          <div style={{ margin: "20px" }}>
            <Button type="main-menu" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GameOutcomeDisplay;
